import { render, staticRenderFns } from "./Connect.vue?vue&type=template&id=02b23237&scoped=true"
import script from "./Connect.vue?vue&type=script&lang=ts"
export * from "./Connect.vue?vue&type=script&lang=ts"
import style0 from "./Connect.vue?vue&type=style&index=0&id=02b23237&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b23237",
  null
  
)

export default component.exports